import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import Grid from "@mui/material/Grid";
import { getSites } from "src/apis/complex";
import { useEffect } from "react";
import "./monitoring.css";
import DoughnutChart from "src/components/DoughnuGauget";
import { usePowerContext } from "src/hooks/use-alert";
import { useAlertContext } from "src/hooks/use-alert";

// Import the marker icon
import {
  redMarkerIcon,
  greenMarkerIcon,
  markerShadow,
} from "src/util/mapImages";

import { useNavigate, useRouteLoaderData, defer } from "react-router-dom";
import { checkSiteAlarms,determineSitesWithAlarms } from "src/util/utilFunctions";
import { useState } from "react";
import { concat } from "lodash";
// Create a custom marker icon


const greenMarker = new L.Icon({
  iconUrl: greenMarkerIcon,
  iconRetinaUrl: greenMarkerIcon,
  shadowUrl: markerShadow,
  iconSize: [27, 40],
  iconAnchor: [16, 32],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const redMarker = new L.Icon({
  iconUrl: redMarkerIcon,
  iconRetinaUrl: redMarkerIcon,
  shadowUrl: markerShadow,
  iconSize: [27, 40],
  iconAnchor: [16, 32],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

// Define the locations and their details

function App() {
  const alert = useAlertContext();
  var locations = [
   
  ];
  const [locations_, setLocations_] = useState([]);
  const [powerItems, setPowerItems] = useState([]);
  const allSites = useRouteLoaderData("monitoring-new");
  const navigate = useNavigate();

  const handleMarkerClick = (site) => {
    if (site.alarm === true) {
      navigate(`/dashboard/alerts-and-notifications`);
    } else {
      navigate(`site/${site.id}`);
    }
  };

  //prendo tutti gli items dell'org dall'oggetto ritornata dalla chiamata API getSites()
  const getAllItems = (allSites) => {
    var x = [];

    allSites.sites.forEach(function (site, i) {
      site.buildings.forEach(function (building, i) {
        building.assets.forEach(function (asset, i) {
          x = concat(x, asset.items);
        });
      });
    });

    x = [...new Set(x)];
    setPowerItems(x);
  };

 
  const updateSites = async () => {
    await getSites().then((res) => {
      if (res && res.length>0) {
        const itemsWithAlarms = checkSiteAlarms(res);
        const sitesWithAlarms=determineSitesWithAlarms(allSites.sites,itemsWithAlarms) 
        locations = sitesWithAlarms;
        console.log(locations);
        setLocations_(locations);
      }
    });
  };


  useEffect(() => {
    if (alert.alarmPageUpdate) { 
      const timeoutId = setTimeout(() => {
        updateSites();
      }, 900); 
     
      alert.setAlarmPageUpdate(false)
    } 


  }, [alert.alarmPageUpdate]);

  

  useEffect(() => {
    if (allSites.sites && allSites.sites.length>0) {
      const itemsWithAlarms = checkSiteAlarms(allSites.sites);
      getAllItems(allSites);
      const sitesWithAlarms=determineSitesWithAlarms(allSites.sites,itemsWithAlarms) 
      locations = sitesWithAlarms;
      console.log(locations);
      setLocations_(locations);
    }
  }, [allSites]);


  const { powers } = usePowerContext();
  const [activePower, setActivePower] = useState(0);
  const [reactivePower, setReactivePower] = useState(0);
  const [energyConsumption, setEnergyConsumption] = useState(0);

  useEffect(() => {
    //se arrivano potenze aggiornate dal socket allora aggiorno i valori degli items appertenenti a questa organization
    if (powers.data.length > 0) {
      powerItems.forEach((item) => {
        var matchedItem = powers.data.find(
          (power) => power.title === item.serialNumber
        );
        if (matchedItem !== undefined) {
          item.lastRegisteredValue = Number.parseFloat(
            matchedItem.value.split(" ")[0].substring(0, 3)
          );
        }
      });
    }

    var newActive = 0;
    var newReactive = 0;
    var energyConsumption = 0;

    //altrimenti sommo la proprietà lastRegisteredValue che appartiene agli items dell'org
    powerItems.forEach((item) => {
      if (item.itemType.name === "Asset Total Power") {
        energyConsumption += item.lastRegisteredValue ?? 0;
      }
      if (item.itemType.name === "Active Power Observer") {
        newActive += item.lastRegisteredValue ?? 0;
      }
      if (item.itemType.name === "Reactive Power Observer") {
        newReactive += item.lastRegisteredValue ?? 0;
      }
    });

    setActivePower(newActive);
    setReactivePower(newReactive);
    setEnergyConsumption(energyConsumption);
  }, [powers.data, powerItems]);

  return (
    <>
      <Grid container height={"100%"}>
        {/* Heading */}
        <Grid item md={12} lg={12} sm={12} xs={12}>
          <h2>Monitoring and Control</h2>
        </Grid>

        {/* Map */}
        <Grid item md={6} lg={6} sm={6} xs={12} height={"calc(100% - 72px)"}>
          <div className="map-container">
            <MapContainer center={[41.9028, 12.4964]} zoom={5}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

              {/* Render the markers */}
              {locations_.length>0 && locations_.map((location, index) => (
                (location.position[0] && location.position[1]) ?
                <Marker
                  key={index}
                  position={location.position}
                  icon={
                    location.alarm === true ? redMarker : greenMarker
                    //  greenMarker
                  }
                  /*icon={customMarkerIcon}*/
                  eventHandlers={{
                    mouseover: (e) => {
                      e.target.openPopup();
                    },
                    mouseout: (e) => {
                      e.target.closePopup();
                    },
                    click: (e) => {
                      handleMarkerClick(location);
                    },
                  }}
                >
                  <Popup>{location.description}</Popup>
                </Marker> :<></>
              ))}
            </MapContainer>
          </div>
        </Grid>

        {/* Gauges */}
        <Grid item md={6} lg={6} sm={6} xs={12} height={"calc(100% - 72px)"}>
          <Grid
            container
            justifyContent={"space-evenly"}
            height={"100%"}
            maxHeight={"100%"}
          >
            {/* Gauge 1 */}
            <Grid
              item
              minWidth={50}
              maxWidth={"40%"}
              maxHeight={"50%"}
              height={"auto"}
              width={"100%"}
              position={"relative"}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
            >
              <DoughnutChart
                currentValue={(activePower / (5 * 1.5)).toFixed(2)}
                maxValue={4.5}
              />
              <div className="cen">Active Power</div>
              <div className="cen">{activePower.toFixed(2) + " kW"}</div>
            </Grid>

            {/* Gauge 2 */}
            <Grid
              item
              minWidth={50}
              maxWidth={"40%"}
              maxHeight={"50%"}
              height={"auto"}
              width={"100%"}
              position={"relative"}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
            >
              <DoughnutChart
                currentValue={(reactivePower / (5 * 1.5)).toFixed(2)}
                maxValue={4.5}
              />
              <div className="cen">Reactive Power</div>
              <div className="cen">{reactivePower.toFixed(2) + " KVAr"}</div>
            </Grid>
            {/* Gauge 3 */}
            <Grid
              item
              minWidth={50}
              maxWidth={"40%"}
              maxHeight={"50%"}
              height={"auto"}
              width={"100%"}
              position={"relative"}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
            >
              <DoughnutChart
                currentValue={(energyConsumption / (5 * 1.5)).toFixed(2)}
                maxValue={4.5}
              />
              <div className="cen">Energy Consuption</div>
              <div className="cen">{energyConsumption.toFixed(2) + " kWh"}</div>
            </Grid>
            {/* Gauge 4 */}
            <Grid
              item
              minWidth={50}
              maxWidth={"40%"}
              maxHeight={"50%"}
              height={"auto"}
              width={"100%"}
              position={"relative"}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
            >
              <div className="showingNumber">{locations_.length}</div>
              <div className="cen">Sites</div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default App;

async function loadSites() {
  const response = await getSites();
  return response;
}

export async function loader({ request, params }) {
  return defer({
    sites: await loadSites(),
  });
}
